import React from 'react';
import { Box } from '@mui/material';

const ButtonContainer = ({ children }: { children: React.ReactNode }) => {
  return (
    <Box
      display="flex"
      justifyContent="flex-end"
      position="absolute"
      right="0px"
      top="0px"
      sx={{
        backgroundColor: '#ffffff94',
        borderRadius: '3px'
      }}
    >
      {children}
    </Box>
  );
};

export default ButtonContainer;
